// Fechas, horas y precios como los escribe una persona en Argentina.
// Todo con Intl, que ya viene en el navegador: cero dependencias.

const ZONA_POR_DEFECTO = 'America/Argentina/Buenos_Aires';

const capitalizar = (texto) => texto.charAt(0).toUpperCase() + texto.slice(1);

/** '2026-09-15' -> 'lunes 15 de septiembre' */
export function fechaLarga(fechaISO, timezone = ZONA_POR_DEFECTO) {
  const formato = new Intl.DateTimeFormat('es-AR', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: timezone
  });
  // es-AR devuelve "lunes, 15 de septiembre"; la coma sobra.
  return formato.format(desdeFechaLocal(fechaISO)).replace(',', '');
}

/** '2026-09-15' -> 'Lun' / '15' / 'sep' para el calendario horizontal. */
export function partesDelDia(fechaISO, timezone = ZONA_POR_DEFECTO) {
  const fecha = desdeFechaLocal(fechaISO);
  const opciones = { timeZone: timezone };
  return {
    diaSemana: capitalizar(
      new Intl.DateTimeFormat('es-AR', { ...opciones, weekday: 'short' }).format(fecha).replace('.', '')
    ),
    numero: new Intl.DateTimeFormat('es-AR', { ...opciones, day: 'numeric' }).format(fecha),
    // Tres letras siempre: es-AR devuelve "sept" para septiembre y esa
    // cuarta letra es la que se desbordaba de la tarjeta.
    mes: new Intl.DateTimeFormat('es-AR', { ...opciones, month: 'short' })
      .format(fecha).replace('.', '').slice(0, 3)
  };
}

/**
 * Una fecha suelta ('2026-09-15') se interpreta al mediodía UTC a propósito:
 * así ninguna zona horaria del planeta la corre al día anterior o al siguiente
 * cuando se la formatea.
 */
function desdeFechaLocal(fechaISO) {
  const [anio, mes, dia] = fechaISO.split('-').map(Number);
  return new Date(Date.UTC(anio, mes - 1, dia, 12));
}

/** 800000 (centavos) -> '$8.000' */
export function precio(centavos) {
  if (centavos == null) return '';
  const pesos = Math.round(centavos / 100);
  return new Intl.NumberFormat('es-AR', {
    style: 'currency', currency: 'ARS', maximumFractionDigits: 0
  }).format(pesos);
}

/** 45 -> '45 min' · 90 -> '1 h 30 min' */
export function duracion(minutos) {
  if (minutos < 60) return `${minutos} min`;
  const horas = Math.floor(minutos / 60);
  const resto = minutos % 60;
  return resto === 0 ? `${horas} h` : `${horas} h ${resto} min`;
}

/** Fecha de hoy ('AAAA-MM-DD') en la zona del negocio. */
export function hoyEn(timezone = ZONA_POR_DEFECTO) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(new Date());
}

/** Suma días a una fecha suelta sin pasar por husos horarios. */
export function sumarDias(fechaISO, dias) {
  const fecha = desdeFechaLocal(fechaISO);
  fecha.setUTCDate(fecha.getUTCDate() + dias);
  return fecha.toISOString().slice(0, 10);
}

export { ZONA_POR_DEFECTO };
